import React from "react";
import styles from "../ritualpraxis.module.css";
import Head from "next/head";
import Image from "next/image";

import Image1 from "../../../public/image/ritual-praxis-and-instructions/page-2/chapter2_Image1.webp";
import Image2 from "../../../public/image/ritual-praxis-and-instructions/page-2/chapter2_Image2.png";
import Image3 from "../../../public/image/ritual-praxis-and-instructions/page-2/chapter2_Image3.png";

export default function Chapter_2() {
  return (
    <>
      <Head>
        <title>Chapter 2 | Ritual Praxis | School of Our Divine Infinite Being</title>
      </Head>


      <div className={`${styles.ritual_praxis_page_part1_main} ${styles.chapter2_main}`}>
        {/* ========== PART 1: DREAM THEURGY SECTION ========== */}

        {/* Orange Banner: Dream Theurgy */}
        <div className={styles.common_width}>
          <div className={styles.orange_heading_section}>
            <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
              <div className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h1>Threshold: Awakening into the Starry Realm</h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.blck_sec_common_width}>
          {/* Block 1: Dream Journals - Image1 LEFT */}
          <div className={`${styles.blck1_main} ${styles.flex_direction_reverse}`}>
            <div className={styles.image_section}>
              <Image className={styles.c2_b1_img} src={Image1} alt="#" />
            </div>
            <div className={styles.content_section_main}>
              <div className={styles.content_section} style={{textAlign: "center"}}>
                <h4 className={styles.green_heading_25} style={{textAlign: "center"}}>Declaration to the Children of Light</h4>

                <p style={{marginBottom: "0px"}}>You have lived beneath the new world master, screens of a technological age.</p>
                <p style={{marginBottom: "0px"}}>You have carried the weight of endless notifications, doom scrolling, thieves of the real — your attention carved into pieces,</p>
                <p><span>your time consumed by machines that never sleep.</span></p>

                <p style={{marginBottom: "0px"}}>You have been measured in metrics,</p>
                <p style={{marginBottom: "0px"}}>your worth reduced to data,</p>
                <p>your desires predicted, purchased, and sold.</p>

                <p style={{marginBottom: "0px"}}><span>This is the world of techno-slavery</span>—</p>
                <p style={{marginBottom: "0px"}}>a world that calls itself connected, yet in its blinding presence offers only a reflection,</p>
                <p style={{marginBottom: "0px"}}>leaving the soul severed from the living whole.</p>
                <p style={{marginBottom: "0px"}}>A world that floods your senses with noise</p>
                <p style={{marginBottom: "0px"}}>yet leaves your spirit starved.</p>
                <p style={{marginBottom: "0px"}}>A world that convinces you</p>
                <p style={{marginBottom: "0px"}}>there is no beyond,</p>
                <p>only consumption until silence.</p>

                <p style={{marginBottom: "0px"}}><span>Lift your eyes.</span></p>
                <p style={{marginBottom: "0px"}}>Above the dead glow of neon lights and this deep pollution of the mind</p>
                <p style={{marginBottom: "0px"}}><span>still shines the sky</span>—</p>
                <p style={{marginBottom: "0px"}}>immeasurable, immense, alive.</p>
                <p style={{marginBottom: "0px"}}>The stars wheel in their eternal rhythm.</p>
                <p style={{marginBottom: "0px"}}>The Moon rises and falls in her silver breath.</p>
                <p style={{marginBottom: "0px"}}>The planets march, radiant gods</p>
                <p style={{marginBottom: "0px"}}>clothed in spheres of fire.</p>
                <p style={{marginBottom: "0px"}}>The Sun blazes, a sovereign intelligence,</p>
                <p style={{marginBottom: "0px"}}>pouring forth life, consciousness,</p>
                <p style={{marginBottom: "0px"}}>and the grammar of time itself.</p>
              </div>
            </div>
          </div>

          {/* Block 2: Childhood Dreams - Image2 RIGHT */}
          <div className={`${styles.blck1_main} ${styles.blck2_main}`}>
            <div className={styles.image_section}>
              <Image className={styles.c2_b2_img} src={Image2} alt="#" />
            </div>
            <div className={styles.content_section_main}>
              <div className={styles.content_section} style={{textAlign: "center"}}>
                <p style={{marginBottom: "0px"}}><span>Here is the truth the world has forgotten:</span></p>
                <p style={{marginBottom: "0px"}}>The cosmos declares that the atheist’s new creed of meaninglessness binds them in chains, delivering them into the service of their technological masters, molded into mimics of their synthetic lords.</p>
                <p style={{marginBottom: "0px"}}>Yet, in truth the great mystery of existence is most certainly alive with divine intelligence, calling us to the freedom of communion, born from the very beginning of the human race.</p>
                <p style={{marginBottom: "0px"}}>The Solar Ātman, the imagination of our Sun, radiates from season to season.</p>
                <p style={{marginBottom: "0px"}}>Each planet within his sphere is a radiant god.</p>
                <p style={{marginBottom: "0px"}}>Each sign in its transition is an infinite gate of meaning.</p>
                <p>The sky is a scripture, speaking in the language of eternity.</p>

                <p style={{marginBottom: "0px"}}><span>To step</span> into Astrological Theurgy is to awaken.</p>
                <p style={{marginBottom: "0px"}}>It is to rise from the dream of machinery</p>
                <p style={{marginBottom: "0px"}}>into the transconscious realm</p>
                <p style={{marginBottom: "0px"}}>where gods speak in symbol, divinatory visions of light, and call you to the eternal;</p>
                <p style={{marginBottom: "0px"}}>where daemons guide the weaving of fate;</p>
                <p style={{marginBottom: "0px"}}>where every hour, every season, every sign</p>
                <p>is a doorway into infinity.</p>

                <p style={{marginBottom: "0px"}}>The Earth beneath your feet is vast and sacred,</p>
                <p style={{marginBottom: "0px"}}>the altar of the rite.</p>
                <p style={{marginBottom: "0px"}}>The Moon is your mirror.</p>
                <p style={{marginBottom: "0px"}}>The Sun is the heart of your Solar Logos.</p>
                <p style={{marginBottom: "0px"}}>The planets are your elder siblings in the order of the cosmos, come to enthrone you in a deep mystery.</p>
                <p><span>The zodiac is your luminous garment, a reflection of the starry heavens.</span></p>

                <p style={{marginBottom: "0px"}}>You are not a number in a system;</p>
                <p style={{marginBottom: "0px"}}><span>you are a microcosm of the All,</span></p>
                <p style={{marginBottom: "0px"}}>a child of the infinite order,</p>
                <p>a soul clothed in constellations.</p>
              </div>
            </div>
          </div>

          {/* Block 3: Dreams as Divine Medium - Image3 LEFT */}
          <div className={`${styles.blck1_main} ${styles.blck3_main} ${styles.flex_direction_reverse}`}>
            <div className={styles.image_section}>
              <Image className={styles.c2_b3_img} src={Image3} alt="#" />
            </div>
            <div className={styles.content_section_main}>
              <div className={styles.content_section} style={{textAlign: "center"}}>
                <p style={{marginBottom: "0px"}}><span>Here begins the ascent of the soul into its starry homeland,</span></p>
                <p style={{marginBottom: "0px"}}>and at once the descent of divine presence into the sacred body,</p>
                <p style={{marginBottom: "0px"}}>your home, your work, your world.</p>
                <p style={{marginBottom: "0px"}}>Here begins your training in symbols, tools, and sacred time.</p>
                <p style={{marginBottom: "0px"}}>Here begins your consecration as a Child of Light,</p>
                <p style={{marginBottom: "0px"}}>a participant in the great harmony</p>
                <p>that turns the heavens and sings through every atom of earth.</p>

                <p style={{marginBottom: "0px"}}>Step across the threshold.</p>
                <p style={{marginBottom: "0px"}}>Remove your shoes.</p>
                <p style={{marginBottom: "0px"}}>The ground is holy.</p>
                <p style={{marginBottom: "0px"}}>The temple is vast.</p>
                <p>The gods await.</p>

                <p style={{marginBottom: "0px"}}><span>O unconquered Sun, sovereign mind among the gods,</span></p>
                <p style={{marginBottom: "0px"}}>By whose light all intelligences shine,</p>
                <p style={{marginBottom: "0px"}}>By whose warmth all life is nourished,</p>
                <p style={{marginBottom: "0px"}}>By whose rhythm astrology is legible—</p>
                <p style={{marginBottom: "0px"}}>Enthrone yourself in our hearts.</p>
                <p style={{marginBottom: "0px"}}>Make our bodies your instruments, our altars your axis, our circles your horizon.</p>
                <p>Let our words be your rays; our virtues, your heat; our deeds, your day.</p>

                <p style={{marginBottom: "0px"}}><span>Children of Light—remember.</span></p>
                <p style={{marginBottom: "0px"}}>You are not exiles in a dead machine; you are citizens of a living order.</p>
                <p style={{marginBottom: "0px"}}>Clothe yourself in the stars.</p>
                <p style={{marginBottom: "0px"}}>Consecrate your place.</p>
                <p style={{marginBottom: "0px"}}>Raise the wand of aspiration; lift the cup of reception; wield the dagger of clarity; set the pentacle of embodiment.</p>
                <p style={{marginBottom: "0px"}}>Greet the statues as doors and the stones as songs.</p>
                <p style={{marginBottom: "0px"}}>Burn the incense <span>before</span> the rite; let the bell divide the hours; let the candles witness, and let your breath become prayer.</p>
                <p style={{marginBottom: "0px"}}>Speak your declarations; listen for the answer in sign and omen, in dream and wind, in steadfast conscience.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
